import React, { useEffect, useState } from "react";
import cn from "classnames";
import Card from "../../components/Card";
import Tabs from "../../components/Tabs";
import Form from "../../components/Form";
import Table from "./Table";
import styles from "./Product.module.sass";
import product_ from "../../i11/Product";
import ProductModal from "../../components/ProductModal";
import CreateProduct from "./CreateProduct";
import TemplateModal from "../NewProduct/TemplateModal";

import { UseApi } from "../../hooks/use-api";
import { useUser } from "../../context";
import { UseDisclosure } from "../../hooks/use-disclosure";
import { GetNFTTemplates } from "../../Services/lib/nfttemplates";

export const PageLimit = 8;
export const options = {
	SINGLE_EDITION: "Unique",
	LIMITED_EDITION: "Standard",
	AUCTION_EDITION: "Auction",
};

const types = {
	Drafts: "DRAFT",
	Published: "ALL",
	Minted: "MINTED",
};

const Product = () => {
	const { locale } = useUser();
	const [index, setIndex] = useState(0);
	const {
		isOpen: createV,
		onOpen: createO,
		onClose: createC,
	} = UseDisclosure();
	const { isOpen, onClose, onOpen } = UseDisclosure();
	const [search, setSearch] = useState("");
	const [product, setProduct] = useState();
	const [initial, setInitial] = useState();
	const [page, setPage_] = useState(1);
	const [isDisable, setDisabled] = useState(false);
	const [total, setTotal] = useState(1);
	const [{ isLoading }, getNFTs] = UseApi({
		service: GetNFTTemplates,
	});
	const [nft, setNft] = useState([]);
	const [item, setItem] = useState();
	const [type, setType] = useState("Published");
	const [filter, setFilter] = useState({
		offset: 0,
		limit: PageLimit,
		sortBy: "updatedAt",
		orderBy: "desc",
		status: "ALL",
		name: "",
		nftTypes: [],
	});

	const getNFTs_ = async () => {
		setNft([]);
		const res = await getNFTs(filter);
		if (res) {
			setNft(res.nftTemplates);
			setTotal(Math.ceil(res.count / PageLimit));
		}
	};
	useEffect(() => {
		getNFTs_();
	}, [filter]);

	useEffect(() => {
		const type_ = types[type];

		if (type_ !== filter.status) {
			setPage_(1);
			setFilter((p) => {
				return {
					...p,
					status: type_,
					offset: 0,
					limit: PageLimit,
				};
			});
		}
	}, [type]);

	const setPage = (e) => {
		setPage_(e);
		const lOffset = (e - 1) * PageLimit;
		if (filter.offset !== lOffset)
			setFilter((p) => {
				return {
					...p,
					offset: lOffset,
				};
			});
	};

	const set_edit = (item, isDisable) => {
		setInitial({
			_id: item._id,
			name: item.name || "",
			description: item.description || "",
			price: item.price || "",
			category: item.category || "",
			tokenType: item.tokenType || "",
			type: options[item.type],
			totalNFTs: item.totalNFTs || "1",
			image: item.image || "",
			endDate: item.endDate || "",
			startDate: item.startDate || "",
			drawHtml: item.drawHtml || "",
			royalties: item.royalties || "",
			skuNumber: item.skuNumber || "",
			nftCollection: item.nftCollection || "",
			shippingInfo: item.shippingInfo || {},
			auctionIncrementType: item.auctionIncrementType || {
				value: 1,
				type: "RAW",
			},
			multiPrices: [...(item?.multiPrices || [])],
			image_list: [...(item?.image_list || [])],
			paymentType: item?.paymentType || "CARD_PAYMENT",
			period_time: item?.period_time || "DAY",
		});
		if (isDisable) setDisabled(true);
		setItem(item);
		createO();
	};

	const close = () => {
		setProduct();
		onClose();
	};

	const open = (data_) => {
		setProduct(data_._id);
		onOpen();
	};

	const CloseC_ = () => {
		createC();
		setItem();
		setInitial();
		setDisabled(false);
	};

	const CloseC = (which = "Published") => {
		setIndex(which === "Published" ? 0 : 1);
		if (which === type) {
			getNFTs_();
		} else {
			setType(which);
		}
		CloseC_();
	};

	const onSubmit = (e) => {
		e.preventDefault();
		if (filter.name !== search) {
			setFilter((p) => {
				return {
					...p,
					name: search,
				};
			});
		}
	};

	const prop = {
		items: nft,
		isLoading,
		page,
		type,
		total,
		filter,
		set_edit,
		getNFTs_,
		setPage_,
		setFilter,
		setPage,
		open,
		closeC: CloseC,
	};
	return (
		<>
			<Card
				title={product_[locale].product}
				// classTitle="title-red"
				classTitle={cn("title-purple", styles.title)}
				classCardHead={styles.head}
				head={
					<>
						<Form
							placeholder={product_[locale].prod_search}
							type="text"
							name="search"
							icon="search"
							required={false}
							value={search}
							setValue={setSearch}
							onSubmit={onSubmit}
						/>

						<button
							type="button"
							onClick={createO}
							className="button-small"
						>
							{product_[locale].create_prod}
						</button>
					</>
				}
			>
				<Tabs
					index={index}
					default_={index}
					head={[product_[locale].published, product_[locale].drafts]}
					body={[<Table {...prop} />, <Table {...prop} />]}
					setType={setType}
					setHandler={setIndex}
				/>
			</Card>
			<ProductModal
				visible={isOpen && product}
				onClose={close}
				data={product}
			/>
			<TemplateModal visible={createV} onClose={CloseC_}>
				{createV && (
					<CreateProduct
						item={item}
						isDisable={isDisable}
						close={CloseC}
						closeNoRef={CloseC_}
						isPublished={type === "Published" && initial}
						initialVal={initial}
					/>
				)}
			</TemplateModal>
		</>
	);
};

export default Product;
